import "./FieldSetToggleButton_module.css";
const FieldSetToggleButton_module = {
    toggleButton: "toggleButton__af80b960d86244cc",
    contentWrapper: "contentWrapper__af80b960d86244cc",
    icon: "icon__af80b960d86244cc",
    label: "label__af80b960d86244cc"
};
export { FieldSetToggleButton_module as default };
